import { IField } from 'app/services/api5-service/api.interface';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  ISPFieldConfig,
  ISPFormState,
  ISPProps,
} from 'common/dynamic-form/model';

import { FieldChipWrapperProps } from './model/field-chip-props.interface';

import { getDesc$ } from '../field-base/description/description.utils';
import { getLabel$ } from '../field-base/label/label.utils';

/**
 * Get props for field chip wrapper
 *
 * @param field
 * @param config
 * @param state
 */
function getFieldChipWrapperProps(
  field: IField,
  config: ISPFieldConfig,
  state: ISPFormState,
): FieldChipWrapperProps {
  return {
    originalField: field,
    chipsLabel$: combineLatest([
      getLabel$(field, state),
      getDesc$(field, state),
    ]).pipe(map(([label, desc]) => (desc ? desc.msg : label))),
  };
}

/**
 * Append props, specific for input-base field wrapper
 *
 * @param config - config to append
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function appendFieldChipOptions(
  config: ISPFieldConfig,
  field: IField,
  state: ISPFormState,
): void {
  const props: FieldChipWrapperProps = getFieldChipWrapperProps(
    field,
    config,
    state,
  );

  config.props = {
    ...config.props,
    ...props,
  } as ISPProps;
}
